<template>
  <div class="content-wrapper">
    <!-- Content Header (Page header) -->
    <section class="content-header">
      <h1>
        审批中心
        <small>审批中心</small>
      </h1>
      <ol class="breadcrumb">
        <li>
          <a href="#">
            <i class="fa fa-dashboard"></i> 审批中心
          </a>
        </li>
        <li class="active">审批中心</li>
      </ol>
    </section>

    <!-- Main content -->
    <section class="content">
      <div class="col-sm-12">
        <div id="atptoolbar">
          <button class="btn btn-warning" type="button" id="sys_judge" @click="judge">
            <i class="fa fa-pencil"></i>&nbsp;审批
          </button>
        </div>
        <table id="approval_list_table"></table>
      </div>
    </section>

    <!-- 审批框 modal -->
    <v-instanceapplypaytasksetup ref="instanceApplyPayTaskSetUp"></v-instanceapplypaytasksetup>
    <v-instanceapplypaytaskpayment ref="instanceApplyPayTaskPayment"></v-instanceapplypaytaskpayment>
    <v-instanceapplycommon ref="instanceApplyCommon"></v-instanceapplycommon>
    <v-instanceapplycollectebills ref="instanceApplyCollectEBills"></v-instanceapplycollectebills>
    <v-instanceapplypayebills ref="instanceApplyPayEBills"></v-instanceapplypayebills>
  </div>
</template>

<script>
import instanceApplyCommon from './instanceApplyCommon'
import instanceApplyPayTaskSetUp from './instanceApplyPayTaskSetUp'
import instanceApplyPayTaskPayment from './instanceApplyPayTaskPayment'
import instanceApplyCollectEBills from './instanceApplyCollectEBills'
import instanceApplyPayEBills from './instanceApplyPayEBills'

export default {
  name: 'approvalList',
  data() {
    return {}
  },
  components: {
    'v-instanceapplycommon': instanceApplyCommon,
    'v-instanceapplypaytasksetup': instanceApplyPayTaskSetUp,
    'v-instanceapplypaytaskpayment': instanceApplyPayTaskPayment,
    'v-instanceapplycollectebills': instanceApplyCollectEBills,
    'v-instanceapplypayebills': instanceApplyPayEBills
  },
  mounted: function () {
    // 获取所有的审批中心
    var self = this
    console.log('___请求数据')
    $('#approval_list_table').bootstrapTable({
      url: self.global.apiHost + 'approval_list/',
      method: 'get', // 请求方式（*）
      ajaxOptions: {
        headers: {
          'content-type': 'application/json', // 默认值
          Authorization: 'Bearer ' + localStorage.getItem('access_token')
        }
      },
      toolbar: '#atptoolbar', // 工具按钮用哪个容器
      height: $(window).height() * 0.86,
      striped: true, // 是否显示行间隔色
      cache: false, // 是否使用缓存，默认为true，所以一般情况下需要设置一下这个属性（*）
      pagination: true, // 是否显示分页（*）
      iconSize: 'outline',
      sortable: true, // 是否启用排序
      sortName: 'id',
      sortOrder: 'DESC', // 排序方式
      queryParams: self.queryParams, // 传递参数（*）
      sidePagination: 'server', // 分页方式：client客户端分页，server服务端分页（*）
      pageNumber: 1, // 初始化加载第一页，默认第一页
      pageSize: 10, // 每页的记录行数（*）
      pageList: [10], // 可供选择的每页的行数（*）
      // search: true, // 是否显示表格搜索，此搜索是客户端搜索，不会进服务端，所以，个人感觉意义不大
      showColumns: true, // 是否显示所有的列
      showRefresh: true, // 是否显示刷新按钮
      minimumCountColumns: 2, // 最少允许的列数
      clickToSelect: true, // 是否启用点击选中行
      singleSelect: true, // 是否启用单选
      uniqueId: 'id', // 每一行的唯一标识，一般为主键列
      responseHandler: function (res) {
        console.log('___获取待审批到数据', res)
        return {
          total: res.total, // 总页数
          rows: res.rows // 数据
        }
      },
      columns: [
        [
          {checkbox: true},
          {
            title: '申请单号',
            width: 40,
            field: 'id'
          },
          {
            title: '创建时间',
            width: 40,
            field: 'create_at'
          },
          {
            title: '流程类型',
            width: 40,
            field: 'define_name'
          },
          {
            title: '发起人',
            width: 40,
            field: 'initiator_name'
          },
          {
            title: '当前节点',
            width: 40,
            field: 'node'
          },
          {
            title: '备注',
            width: 40,
            field: 'note'
          },
          {
            title: '状态',
            width: 40,
            field: 'state',
            formatter: function (value, row, index) {
              const stateDict = {
                1: '进行中',
                2: '完成',
                3: '失败'
              }
              return stateDict[value] || '未知类型'
            }
          }
        ]
      ]
    })
  },
  methods: {
    queryParams: function (param) {
      console.log()
      param.org_id = JSON.parse(localStorage.getItem('companyInfo')).id
      param.per_page = param.limit
      param.page = param.offset / param.limit + 1
      return param
    },
    // 审批
    judge: function () {
      var self = this
      var selectedRows = $('#approval_list_table').bootstrapTable('getSelections')
      console.log('___已选中的行', selectedRows)
      if (selectedRows.length !== 1) {
        alert('必须只选择一项')
        return
      }

      setTimeout(function () {
        switch (selectedRows[0].define_id) {
          case 7:
            console.log('___结费任务审批', selectedRows[0])
            self.$refs.instanceApplyPayTaskSetUp.initFunc(selectedRows[0]) // 调用子组件函数
            break
          case 8:
            console.log('___收付申请审批', selectedRows[0])
            self.$refs.instanceApplyPayTaskPayment.initFunc(selectedRows[0]) // 调用子组件函数
            break
          case 9:
            console.log('___收电费审批', selectedRows[0])
            self.$refs.instanceApplyCollectEBills.initFunc(selectedRows[0]) // 调用子组件函数
            break
          case 10:
            console.log('___付电费审批', selectedRows[0])
            self.$refs.instanceApplyPayEBills.initFunc(selectedRows[0]) // 调用子组件函数
            break
          default:
            console.log('___默认审批类型', selectedRows[0])
            self.$refs.instanceApplyCommon.initFunc(selectedRows[0]) // 调用子组件函数
        }
      }, 1000)
    }
  }
}
</script>
<style scoped>
</style>



// WEBPACK FOOTER //
// src/views/approvalCenter/approvalCenter.vue